import type { ReactNode } from "react";
import { useAuth } from "tecrmi_components/useAuth";
import { AuthBridge } from "@xplatform/platform";
import { LoadingScreen } from "@components/LoadingScreen";

interface Props {
  children: ReactNode;
}

/**
 * Bridges BeeHive's `useAuth()` into the shared token store via the platform
 * `AuthBridge`, holding render until the first token has arrived so the first
 * request never goes out unauthenticated. The BeeHive hook stays imported here
 * (not in the shared package): `tecrmi_components/useAuth` only resolves inside
 * this app's vite config (or the dev-only preview alias to a fake hook).
 */
export const ModuleContextProvider = ({ children }: Props) => {
  const auth = useAuth();
  return (
    <AuthBridge
      auth={auth}
      fallback={<LoadingScreen message="Checking authentication..." />}
    >
      {children}
    </AuthBridge>
  );
};
